import {ChangeDetectorRef, Component, Input, OnInit, ViewChild} from '@angular/core';
import {LemDto} from '@dashboard/modules/other-operations/lem-info/model/lem.dto';
import {PrimengLocal} from '@app/modules/shared/constants/primeng-local';
import {TranslateService} from '@app/modules/shared/services/translate/translate.service';
import {UtilService} from '@app/modules/shared/services/util.service';
import {ApiService} from '@app/modules/shared/services/base/api.service';
import {KlSweetAlertService} from '@app/modules/shared/services/message/kl-sweet-alert.service';
import {ToastService} from '@app/modules/shared/services/message/toast.service';
import {KlLoadingService} from '@app/modules/shared/services/kl-loading.service';
import {ExplorerService, ModalConfig} from '@app/modules/shared/services/explorer.service';
import {GridComponent} from "@app/modules/shared/components/grid/grid.component";
import {DynamicComponent} from "@app/data/dashboard/interfaces/dynamic-component.interface";
import {
    CustomerListComponent
} from "@dashboard/modules/shipping-management/customer/components/customer-list/customer-list.component";

@Component({
    selector: 'kl-lem-info-form',
    templateUrl: './lem-info-form.component.html',
    styleUrls: ['./lem-info-form.component.scss']
})
export class LemInfoFormComponent implements OnInit {
    locale = PrimengLocal[
        localStorage.getItem('currentLanguage')
            ? localStorage.getItem('currentLanguage').toUpperCase()
            : 'TR'
        ];
    @ViewChild('gridComponent', {static: false}) gridComponent: GridComponent;
    @Input() entity: LemDto = new LemDto();
    @Input() tabId: string;
    @Input() listTabId: string;
    @Input() modalId: string;
    @Input() dataContext: any;
    alertShow = false;
    alertType = 'success';
    alertMessage: any;
    mode = 'add';
    title = '';
    isReadOnly = false;
    accordions = {
        general_information: true,
        logo_get_info: false
    };
    tunnel: any;
    masterDbCreateDate: Date;
    lemEndDate: Date;
    logoLicenseFlags: { label: string; checked: boolean; displayValue: string }[] = [];

    constructor(
        private translateService: TranslateService,
        private utilService: UtilService,
        private apiService: ApiService,
        private klAlertService: KlSweetAlertService,
        private toastService: ToastService,
        private changeDetector: ChangeDetectorRef,
        private klLoadingService: KlLoadingService,
        private explorerService: ExplorerService
    ) {
        this.tunnel = this.explorerService.transferState$.subscribe((state) => {
            this.formChange(true);
            if (state) {
                switch (state.state) {
                    case 'CUSTOMER_CURRENT_ITEM':
                        this.entity.customer = state.payload;
                        break;
                }
            }
        });
    }

    ngOnInit(): void {
        if (this.entity) {
            const decrypted = this.decryptEntity(this.entity);
            Object.assign(this.entity, decrypted);
            if (this.entity.master_db_create_date) {
                this.masterDbCreateDate = new Date(this.entity.master_db_create_date);
            }
            if (this.entity.lem_end_date) {
                this.lemEndDate = new Date(this.entity.lem_end_date);
            }
            if ((this.entity as any)._customer) {
                if (!this.entity.customer || typeof this.entity.customer !== 'object') {
                    this.entity.customer = {} as any;
                }
                this.entity.customer.code = (this.entity as any)._customer.customer_code;
                this.entity.customer.description = (this.entity as any)._customer.customer_description;
                this.entity.customer.id = (this.entity as any)._customer.customer_id;
            }
            this.normalizeLicenseFlags();
            this.fixAddress();

            this.parseLogoLicenseFlags();
            setTimeout(() => {
                this.changeDetector.detectChanges();
            }, 0);
        }
    }
    private normalizeLicenseFlags(): void {
        if (!this.entity.license_flags) {
            this.entity.license_flags = [];
        }
        const normalizedFlags: string[] = [];
        for (let i = 0; i < 8; i++) {
            let value: any = this.entity.license_flags[i];

            if (value === null ||
                value === undefined ||
                value === '' ||
                value === 'null' ||
                value === 'undefined' ||
                value === '0') {
                normalizedFlags[i] = '0';
            } else if (value === '1') {
                normalizedFlags[i] = '1';
            } else {
                normalizedFlags[i] = '0';
            }
        }

        this.entity.license_flags = normalizedFlags;
    }
    private fixAddress(): void {
        if (!this.entity.address || this.entity.address === 'undefined' || this.entity.address === 'null') {
            this.entity.address = null;
        }
        if (!this.entity.address && (this.entity as any)._customer) {
            const customerAddress = (this.entity as any)._customer.address ||
                (this.entity as any)._customer.customer_address;
            if (customerAddress) {
                this.entity.address = customerAddress;
            }
        }
    }
    ngAfterViewInit(): void {
    }

    /**
     * LOGO_LICENSE_FLAGS aslında ayrılaiblir bir string misal: P164:1;P93:1;P212:1;P195:0;;P9000:1;P9001:1;P9002:1;P9014:0;;;P9017:0;;P9019:0
     */
    private parseLogoLicenseFlags(): void {
        this.logoLicenseFlags = [];
        const rawString = this.entity.logo_license_flags;
        const testData = 'xyz';
        const source = rawString.trim() !== '' ? rawString : testData;
        const regex = /P(\d+):(\d+)/g;
        const parsedMap = new Map<string, string>();
        let match;
        while ((match = regex.exec(source)) !== null) {
            parsedMap.set(match[1], match[2]);
        }
        const flagDefinitions = [
            {code: '195', label: this.translateService.instant('market_available')},      // Market
            {code: '164', label: this.translateService.instant('market_branch_count')},   // Market Şube Sayısı
            {code: '93', label: this.translateService.instant('purchase_available')},    // Satınalma
            {code: '9000', label: this.translateService.instant('tpos_available')},        // Tpos
            {code: '9001', label: this.translateService.instant('tpos_branch_count')},     // Tpos Şube Sayısı
            {code: '9032', label: this.translateService.instant('fuel_available')},        // Akaryakıt
            {code: '9033', label: this.translateService.instant('fuel_branch_count')},     // Akaryakıt Şube Sayısı
            {code: '9014', label: this.translateService.instant('fpos_license_count')},    // Fpos Lisans Sayısı
        ];

        flagDefinitions.forEach(def => {
            const val = parsedMap.get(def.code) || '0';
            const isChecked = val !== '0';
            const displayVal = val !== '0' ? val : '';
            this.logoLicenseFlags.push({
                label: def.label,
                checked: isChecked,
                displayValue: displayVal
            });
        });
    }
    private decryptEntity(data: any): LemDto {
        const errors: string[] = [];
const safeDecrypt = (fieldName: string, value: any): string | null => {
    if (value == null) return null;
    try {
        const cleaned = String(value).replace(/\s/g, '');
        return UtilService.decryptString(cleaned);
    } catch (error) {
        const msg = `${fieldName}: ${value}`;
        console.error(msg, error);
        errors.push(msg);
        return '';
    }
};
        const decrypted: LemDto = {
            active: safeDecrypt('active', data.active),
            address: data.address,
            city: safeDecrypt('city', data.city),
            company_title: safeDecrypt('company_title', data.company_title),
            country: safeDecrypt('country', data.country),
            district: safeDecrypt('district', data.district),
            file_version: safeDecrypt('file_version', data.file_version),
            filo: safeDecrypt('filo', data.filo),
            ids: safeDecrypt('ids', data.ids),
            logo_product_key: safeDecrypt('logo_product_key', data.logo_product_key),
            master_db_id: safeDecrypt('master_db_id', data.master_db_id),
            master_db_name: safeDecrypt('master_db_name', data.master_db_name),
            product_id: safeDecrypt('product_id', data.product_id),
            product_version: safeDecrypt('product_version', data.product_version),
            sql_server_name: safeDecrypt('sql_server_name', data.sql_server_name),
            sql_server_thumbprint: safeDecrypt('sql_server_thumbprint', data.sql_server_thumbprint),
            tax_nr: safeDecrypt('tax_nr', data.tax_nr),
            tax_office: safeDecrypt('tax_office', data.tax_office),
            customer: data.hasOwnProperty('customer_id')
                ? safeDecrypt('customer_id', data.customer_id)
                : undefined,
            branch_count: data.branch_count,
            lem_end_date: data.lem_end_date,
            logo_license_flags: data.logo_license_flags,
            master_db_create_date: data.master_db_create_date,
            license_flags: (data.license_flags || []).map((x, i) =>
                safeDecrypt(`license_flags[${i}]`, x)
            ),
        };

        if (errors.length > 0) {
            console.warn(`Toplam ${errors.length} alan çözülemedi.`);
            console.table(errors);
        }
        return decrypted;
    }
    setModal() {
        const modalConfig = <ModalConfig>{
            title: "customers",
            stateSelector: "CUSTOMER",
            childTemplate: <DynamicComponent>{
                mode: "DIALOG",
                dblSelect: true,
                template: CustomerListComponent,
            },
        };
        this.explorerService.openModal(modalConfig);
    }
    clearCurrentAccount(): void {
        this.entity.customer = null;
        this.formChange(true);
    }
    formChange(event: any): void {
        if (this.tabId) {
            this.explorerService.changeFormStatus({
                tabId: this.tabId,
                changeForm: event,
            });
        }
    }
    onlyNumber(event: any): void {
        const value = event.target.value;
        event.target.value = value.replace(/[^0-9]/g, '');
        this.entity.branch_count = event.target.value;
    }
commitSave($event: any): void {
    this.entity.master_db_create_date = this.masterDbCreateDate
        ? this.masterDbCreateDate.getTime()
        : null;
    this.entity.lem_end_date = this.lemEndDate
        ? this.lemEndDate.getTime()
        : null;

    const lf = this.entity.license_flags || [];

    const toNumberOrNull = (val: any): number | null => {
        if (val === null || val === undefined || val === '' || val === 'null' || val === 'undefined') {
            return null;
        }
        const num = Number(val);
        return isNaN(num) ? null : num;
    };

    const toStringOrNull = (val: any): string | null => {
        if (val === null || val === undefined || val === '' || val === 'null' || val === 'undefined') {
            return null;
        }
        return String(val);
    };

    // Kullanıcı tarafından boşaltılabilen metin alanları için: null/undefined değilse boş string olarak gönder
    const toStringOrKeep = (val: any): string | null => {
        if (val === null || val === undefined) return null;
        return String(val);
    };

    const payload: any = {
        active: toStringOrNull(this.entity.active),               // dropdown -> null/"" => null
        tax_nr: toStringOrKeep(this.entity.tax_nr),
        satinalma: lf[0] === '1' ? '1' : '0',
        kantin: lf[1] === '1' ? '1' : '0',
        market: lf[2] === '1' ? '1' : '0',
        tpos: lf[3] === '1' ? '1' : '0',
        akaryakit: lf[4] === '1' ? '1' : '0',
        bayi: lf[6] === '1' ? '1' : '0',

        //logo_product_key: toStringOrKeep(this.entity.logo_product_key),
        tax_office: toStringOrKeep(this.entity.tax_office),
        company_title: toStringOrKeep(this.entity.company_title),
        address: toStringOrKeep(this.entity.address),
        country: toStringOrKeep(this.entity.country),
        city: toStringOrKeep(this.entity.city),
        district: toStringOrKeep(this.entity.district),
        file_version: toStringOrKeep(this.entity.file_version),
        product_id: this.entity.product_id ? Number(this.entity.product_id) : null,
        product_version: toStringOrKeep(this.entity.product_version),
        sql_server_name: toStringOrKeep(this.entity.sql_server_name),
        sql_server_thumbprint: toStringOrKeep(this.entity.sql_server_thumbprint),
        master_db_name: toStringOrKeep(this.entity.master_db_name),
        // master_db_id: toStringOrKeep(this.entity.master_db_id),
        id: toNumberOrNull(this.entity.ids),
        sube_sayisi: Number(this.entity.branch_count),
        master_db_create_date: this.entity.master_db_create_date,
        lem_end_date: this.entity.lem_end_date,
    };

      /*if (this.entity.master_db_id !== null && 
        this.entity.master_db_id !== undefined && 
        this.entity.master_db_id !== '') {
        payload['master_db_id'] = Number(this.entity.master_db_id);
    }*/

    if (this.entity.customer?.id) {
        payload['customer_id'] = this.entity.customer.id;
    }

    const apiUrl = 'license-package/license-control';

    if (this.mode === 'add' || this.mode === 'copy') {
        this.klLoadingService.show('saving');
        this.apiService.addData(apiUrl, payload).subscribe(
            (response) => this.handleResponse(response),
            (error) => this.handleError(error)
        );
    } else if (this.mode === 'edit') {
        this.klLoadingService.show('updating');
        this.apiService.updateData(apiUrl, payload).subscribe(
            (response) => this.handleResponse(response),
            (error) => this.handleError(error)
        );
    }
}
    handleResponse(response: any): void {
        this.klLoadingService.hide();
        this.toastService.toastSuccess();
        this.formChange(false);

        if (this.tabId) {
            this.explorerService.closeTab(this.tabId);
        } else if (this.modalId) {
            this.explorerService.closeModal(this);
        }
        if (this.listTabId) {
            this.explorerService.setRefreshEndProsseses(this.listTabId);
        }
    }
    handleError(error: any): void {
        this.alertShow = true;
        this.alertType = 'error';
        this.alertMessage = this.utilService.alertErrorMessage(error);
        this.klLoadingService.hide();
    }
    ngOnDestroy(): void {
        this.klLoadingService.hideLoading();
        this.klLoadingService.hide();
        if (this.tunnel) {
            this.tunnel.unsubscribe();
        }
    }
}